(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('SuggestionAddonController', SuggestionAddonController);

    SuggestionAddonController.$inject = ['$scope', '$rootScope', 'Principal', 'Suggestions', 'Connexion'];

    function SuggestionAddonController($scope, $rootScope, Principal, Suggestions, Connexion) {
        var vm = this;

        vm.displayedPeople = [];
        vm.suggestions = [];
        vm.profileToConnect = null;
        vm.connect = connect;

        $scope.suggestionBusyPromise = Suggestions.get(60).then(function (results) {
            vm.suggestions = results;
            vm.displayedPeople = results.slice(0, 3);
        });

        function connect(profileId, grade) {
            vm.profileToConnect = profileId;
            var connection = {
                creator: {
                    id: Principal.profile.id
                },
                grade: grade,
                target: {
                    id: profileId
                }
            };
            Connexion.save(connection, onSaveSuccess, angular.noop);

        }

        function onSaveSuccess() {
            vm.suggestions = vm.suggestions.filter(function (profile) {
                return profile.id !== vm.profileToConnect;
            });
            vm.displayedPeople = vm.suggestions.slice(0, 3);

            // firing an event upwards
            $rootScope.$broadcast('quilinkApp:connexionUpdate', null);
        }
    }
})();
